import FieldArray from "@/components/form/FieldArray.tsx";
import {Button} from "@/components/ui/button.tsx";
import {Plus, X} from "lucide-react";
import TextField from "@/components/editor/fields/TextField.tsx";
import FieldObject from "@/components/form/FieldObject.tsx";
import {Label} from "@/components/ui/label.tsx";
import {Checkbox} from "@/components/ui/checkbox.tsx";
import Field from "@/components/form/Field.tsx";
import {RequiredValidator} from "@/components/form/Helpers.ts";
import {NumericFormat} from "react-number-format";
import {cn} from "@/lib/utils.ts";
import CurrencyField from "@/components/editor/fields/CurrencyField.tsx";
import {defaultContext, FormContext} from "@/components/form/Form.tsx";
import DatePicker from "@/components/ui/date-picker.tsx";

export default function MemberEditor() {
    return (

        <FieldArray name={"cegkepviseletArray"} end={(actions) =>
            <Button onClick={() => {
                actions.add({
                        general: {
                            name: "",
                            birth_date: new Date(),
                            isPerson: true,
                            first_meet: false,
                            cover: false,
                            szindikatus: {value: 100000, valuta: "HUF"},
                            tulajdonosi_resz: 100,
                        },
                        nyugdij: {
                            mod: "kamat",
                            monthly_need: {value: 100000, valuta: "HUF"},
                            monthly_actual: {value: 100000, valuta: "HUF"},
                            slider: [0, 65, 75],
                            longtext: "-",
                            szja: false
                        }
                    }
                )
            }}><Plus/></Button>
        }>
            {
                (array) => array.map((actions, index) => {
                    return <div key={actions.key}
                                className={"grid grid-cols-[1fr_1fr_1fr_1fr_1fr_auto] gap-x-4 items-end bg-white p-4 rounded-md"}>
                        <FieldObject name={"general"}>
                            <TextField
                                className={cn(actions.getValues()["general"]["isPerson"] ? "col-span-2" : "col-span-3")}
                                name={"name"} label={"Név"}/>
                            {
                                actions.getValues()["general"]["isPerson"] &&
                                <Field name={"birth_date"}>
                                    {(field) => (
                                        <DatePicker label={"Születési dátum"}  {...field}/>
                                    )}
                                </Field>
                            }
                            <Field name={"tulajdonosi_resz"} validate={(v) => RequiredValidator(v, "Tulajdonosi rész")}>
                                {(field) => (
                                    <Label aria-invalid={!!field.error}>Tulajdonosi hányad
                                        <NumericFormat
                                            className={cn(
                                                "border-input file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground flex h-9 w-full min-w-0 rounded-md border bg-white px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
                                                "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
                                                "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive text-right"
                                            )}
                                            aria-invalid={!!field.error}
                                            value={field.value}
                                            onValueChange={(v) => {
                                                field.onChange(v.floatValue)
                                            }}
                                            allowNegative={false}
                                            suffix={"%"}
                                            onBlur={field.onBlur}
                                            isAllowed={(values) => {
                                                if (values.floatValue) {
                                                    if (values.floatValue > 100) return false
                                                    if (values.floatValue < 0) return false
                                                    return true
                                                } else {
                                                    return true
                                                }
                                            }}
                                        />
                                        <div className={"h-4"}>
                                            <span
                                                className={"text-destructive text-sm"}>{field.error ? field.error.text : ""}</span>
                                        </div>
                                    </Label>
                                )}
                            </Field>
                            {
                                actions.getRootForm()?.getValue("theme")?.["szindikatus"] ?
                                    <CurrencyField name={"szindikatus"}
                                                   label={"Szindikátusi (kockázati bizt. összeg)"}/> : <div></div>
                            }
                            <Button variant={"outline"} className={"mb-4"}
                                    onClick={() => actions.remove(index)}><X/></Button>
                            <Field name={"first_meet"}>
                                {(field) => (
                                    <Label className={"flex gap-2 items-center pb-4"}>
                                        <Checkbox checked={field.value} onCheckedChange={field.onChange}/>
                                        <p>
                                            Első találkozón részt vett?
                                        </p>
                                    </Label>
                                )}
                            </Field>
                            <FormContext.Provider value={actions.getRootForm() ?? defaultContext}>
                                <Field name={"cegkepviselet_alairo"}>
                                    {(field) => (
                                        <Label className={"flex gap-2 items-center pb-4"}>
                                            <Checkbox checked={field.value === index}
                                                      onCheckedChange={(checked) => {
                                                          if (checked) {
                                                              field.onChange(index)
                                                          } else {
                                                              field.onChange(undefined)
                                                          }
                                                      }}/>
                                            <p>
                                                Aláíró? (Titoktartási nyilatkozat)
                                            </p>
                                        </Label>
                                    )}
                                </Field>
                            </FormContext.Provider>
                            <Field name={"cover"}>
                                {(field) => (
                                    <Label className={"flex gap-2 items-center pb-4"}>
                                        <Checkbox checked={field.value} onCheckedChange={field.onChange}/>
                                        <p>
                                            Borítón szerepeljen?
                                        </p>
                                    </Label>
                                )}
                            </Field>
                        </FieldObject>
                    </div>
                })
            }
        </FieldArray>

    )
}